import Grid from "@/components/Grid";
import { useChannelFeatureEpisodesQuery } from "@/hooks";
import { GRID_PAGE_LIMIT } from "@/lib/constants";

export default function ChannelFeatureEpisodesGrid({ id, ...props }) {
  const { data, ...result } = useChannelFeatureEpisodesQuery({
    variables: { id: parseInt(id, 10), offset: 0, limit: GRID_PAGE_LIMIT },
    nextFetchPolicy: "cache-first",
  });
  const items = data?.channelFeatureEpisodes;

  return (
    <Grid
      {...props}
      items={items}
      {...result}
      limit={GRID_PAGE_LIMIT}
      viewTypeClassName="grid"
    />
  );
}
